var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlusCrFrGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99998 2.66659C5.05446 2.66659 2.66665 5.0544 2.66665 7.99992C2.66665 10.9454 5.05446 13.3333 7.99998 13.3333C10.9455 13.3333 13.3333 10.9454 13.3333 7.99992C13.3333 5.0544 10.9455 2.66659 7.99998 2.66659ZM1.33331 7.99992C1.33331 4.31802 4.31808 1.33325 7.99998 1.33325C11.6819 1.33325 14.6666 4.31802 14.6666 7.99992C14.6666 11.6818 11.6819 14.6666 7.99998 14.6666C4.31808 14.6666 1.33331 11.6818 1.33331 7.99992Z",
    fill: "#56777F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00002 4.66675C8.36821 4.66675 8.66669 4.96522 8.66669 5.33341V7.33341H10.6667C11.0349 7.33341 11.3334 7.63189 11.3334 8.00008C11.3334 8.36827 11.0349 8.66675 10.6667 8.66675H8.66669V10.6667C8.66669 11.0349 8.36821 11.3334 8.00002 11.3334C7.63183 11.3334 7.33335 11.0349 7.33335 10.6667V8.66675H5.33335C4.96516 8.66675 4.66669 8.36827 4.66669 8.00008C4.66669 7.63189 4.96516 7.33341 5.33335 7.33341H7.33335V5.33341C7.33335 4.96522 7.63183 4.66675 8.00002 4.66675Z",
    fill: "#56777F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusCrFrGray);
export default __webpack_public_path__ + "static/media/plus_cr_fr_gray.cde769a51267cf143bd8e4d4e5ec60f6.svg";
export { ForwardRef as ReactComponent };